import { Box } from '@chakra-ui/react';
import Projects from '../components/projects/Projects'; 


const Dashboard = () => {


  return (
    <Box p={10}>

      <Projects />
      
    </Box>
  );
};

export default Dashboard;